import api from "./api";

export const invoiceService = {

  // 📄 Get invoice data
  getInvoice: async (saleId) => {
    try {
      const res = await api.get(`/invoice/${saleId}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

};